import { render, staticRenderFns } from "./ButtonChangeStateBed.vue?vue&type=template&id=9e2bac0c&"
import script from "./ButtonChangeStateBed.vue?vue&type=script&lang=js&"
export * from "./ButtonChangeStateBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports